var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var _excluded = ["lazyload", "alt"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
import React from "react";
import LazyLoad from "react-lazyload";
var Image = /* @__PURE__ */ React.forwardRef(function(_ref, ref) {
  var _ref$lazyload = _ref.lazyload, lazyload = _ref$lazyload === void 0 ? null : _ref$lazyload, alt = _ref.alt, props = _objectWithoutProperties(_ref, _excluded);
  var imgSection = /* @__PURE__ */ React.createElement("img", _extends({}, alt ? {
    alt
  } : null, props, {
    ref
  }));
  return lazyload ? /* @__PURE__ */ React.createElement(LazyLoad, lazyload, imgSection) : imgSection;
});
export {
  Image
};
